import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface FaqRequest {
    category: string;
    limit: string;
    page: number;
    // search: "subject" | "contents";
    search: string;
    searchtxt: string;
}
export type DataListProps = {
    list_no: number;
    subject: string;
    contents: string;
    counter: number;
    notice: number;
    w_date: string;
};

export interface FaqResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleFaq = ({ category, search, searchtxt, page, limit }: FaqRequest): UseQueryResult<FaqResponseData, Error> => {
    let url = enum_api_uri.get_console_faq.replace(":category", category);
    return useQuery({
        queryKey: ["useGetConsoleFaq", category, search, searchtxt, page, limit],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    search,
                    searchtxt,
                    page,
                    limit,
                },
            });
            return response.data.data;
        },
    });
};
